// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';

interface FormControlLabelProps {
  label: string;
  required?: boolean;
  endAdornment?: React.ReactNode;
}
export const FormControlLabel: React.FC<FormControlLabelProps> = ({
  required,
  label,
  endAdornment,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography
        fontWeight="bold"
        variant="caption"
        color="secondary"
        sx={{ textTransform: 'uppercase' }}
      >
        {label}
      </Typography>
      {required && <Typography color="error">*</Typography>}
      {endAdornment}
    </Box>
  );
};
